'use strict';

var processInclude = require('base/util');

function getSuggestionsShadeProduct(scope) {
    if ($(scope).attr('data-id').length >= 3) {
        $("#vto-sf-modal").spinner().start();
        $.ajax({
            context: scope,
            url: $(".url-vto-seggestion-product").attr('data-url') + $(scope).attr('data-id'),
            method: 'GET',
            success: processResponseShade,
            error: function () {
                $.spinner().stop();
            }
        });
        $('.product-view-suggestion').removeClass('col-md-4').addClass('col-md-12');
    } else {
        getSuggestionsShadeWrapper(scope).empty();
    }
}

function processResponseShade(response) {
    var $suggestionsWrapper = getSuggestionsShadeWrapper(this).empty();
    $.spinner().stop();
    if (!(typeof (response) === 'object')) {
        $suggestionsWrapper.append(response).fadeIn();
        $('#no-result-search').text($('.search-field').val());
        $('body').trigger('LoadSliderImages');
    } else {
        $suggestionsWrapper.fadeOut();
    }
    $('.custom-shade-search').show();
    
    if ($(window).outerWidth() < 500) {
        $('.pdp-title-mobile').show();
    }
    $('#YMK-wrapper').focus();
}

function getSuggestionsShadeWrapper(scope) {
    return $(scope).parents('.custom-shade-search').find('.suggestions-shade-wrapper');
}

$(document).ready(function () {
    processInclude(require('./product/pdpRework/vto-modal'));
    processInclude(require('./product/pdpRework/virtualtry'));
    $(document).on('click', '#virtual-try-pdp .shadefinder-shadesquare', function () {
        getSuggestionsShadeProduct($(this));
        if(!($(this).hasClass('disabledshade'))){
            window.YMK.applyMakeupBySku($(this).attr('data-id'));
        }
    });
});
